export const constants = {
    color: {
        white: "#FFFFFF",
        magenta: "#F792DE",
        cyan: "#7299DF",
        black: "#171717",
        black2: "#131313",
        darkBlack: "#0B0000",
        darkGray: "#262626",
        grey: "#D9D9D9",
        red: "#D10000",
        alizarin: "#DE2B2B",
        grey15: "#DDDDDD",
        grey35: "#757575",
        grey20: "#B2B2B2",
        grey30: "#8C8C8C",
        grey40: "#595959",
    },
    fontWeight: {
        thin: 300,
        semi: 350,
        regular: 400,
        plus: 450,
        bold: 700,
        bolder: 900,
    },
    copy: {
        prompt: {
            inputPlaceholder: "Describe the watch you are looking for.",
            caption_1: "Good afternoon, how can we assist you?",
            thinking_copy: "Thinking",
        },
        featuredProduct: {
            heading: "Online Exclusive",
            eyebrow: "Spirit of big bang",
            productName: "Sang Bleu Sapphire",
            size: "42mm",
            price: "USD 143,000",
        },
        productItem: {
            eyebrow: "Big bang",
            productName: "Meca-10 king gold 45",
            variants: [
                {
                    id: 1,
                    size: "44mm",
                    price: "USD 46,000",
                },
                {
                    id: 2,
                    size: "42mm",
                    price: "USD 46,500",
                },
            ],
        },
        exploreMore: {
            heading: "More to explore",
        },
        proposals: {
            heading: "Recommendations",
        },
        staticHeader: {
            caption: "Not quite what you’re looking for? ",
            help: "Let’s help you find the perfect watch.\nPerhaps something a different material or colour?",
            cta: "TELL US MORE",
            recommendations: "Some recommendations",
            recommendation_1: "Stainless steel with black rubber straps",
        },
        staticHeadline: {
            heading: "Pursue our most popular watches",
            message:
                "Seeking novelty? Explore new horizons with our unique offerings. Break the routine and discover fresh\n experiences tailored just for you. Ready to step into the extraordinary?",
        },
        searchHistory: {
            heading: "Previous prompts",
            cta: "Revisit",
        },
        entryPoint: {
            eyebrow: "Good afternoon,how can we assist?",
        },
        endPagePrompt: {
            headline: "Not quite what you’re looking for?",
            subHeadline:
                "Here are some other features to consider. ",
        },
    },
    dimensions: {
        maxWidth: 1440,
        header: {
            desktop: {
                height: 97,
            },
        },
        footer: {
            desktop: {
                height: 200,
            },
        },
    },
};
